import axios from '@/axios/api.request'

export const month = (params) => axios.request({
    url: '/statis/month',
    data: params,
    method: 'post'
  })
